import { render } from "./QOrganizationalGovernance.vue?vue&type=template&id=1bb5f805&ts=true"
import script from "./QOrganizationalGovernance.vue?vue&type=script&lang=ts"
export * from "./QOrganizationalGovernance.vue?vue&type=script&lang=ts"

import "./QOrganizationalGovernance.vue?vue&type=style&index=0&id=1bb5f805&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__